import { GridContainer, GridItem, MediumButton, SecurityGuard, SecurityRole } from "@duosoftbg/nacid-components";
import { Typography } from "@mui/material";
import React, { Fragment } from "react";
import { openModal } from "../../../../../../store/redux/slice/ComponentsControl/groupsControl";
import useAppDispatch from "../../../../../../hooks/redux/base/useAppDispatch";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const GroupButtonWrapper = styled.a`
  text-decoration: none;
  color: ${(props) => props.theme.palette.primary.light};
  cursor: pointer;

  :hover {
    text-decoration: underline;
  }
`;

const GroupHierarchyContent = ({ group, modalType }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const handleOpenModal = (id, modalType) => {
    const payload = { id, modalType };
    dispatch(openModal(payload));
  };

  return (
    <GridContainer spacing={3} mt={0}>
      <GridItem
        sm={modalType === "edit" && group?.childrenGroups.length === 0 ? 10 : 12}
        md={modalType === "edit" && group?.childrenGroups.length === 0 ? 10 : 12}
      >
        <Typography variant="h6" gutterBottom component="span">
          {group?.parentGroups?.map((x) => {
            return (
              <Fragment key={"hierarchy-parents-" + x.id}>
                <GroupButtonWrapper onClick={() => handleOpenModal(x.id, modalType)}>{x?.name}</GroupButtonWrapper>
                <Typography variant="h6" gutterBottom component="span">
                  {" -> "}
                </Typography>
              </Fragment>
            );
          })}
        </Typography>
        <Typography variant="h6" gutterBottom component="span" style={{ color: "green" }}>
          {group?.group?.name}
        </Typography>
        <Typography variant="h6" gutterBottom component="span">
          {group?.childrenGroups.length > 0 && " -> "}
          {group?.childrenGroups?.map((x, index) => {
            return (
              <Fragment key={"hierarchy-children-" + x.id}>
                <GroupButtonWrapper onClick={() => handleOpenModal(x.id, modalType)}>{x?.name}</GroupButtonWrapper>
                {index < group?.childrenGroups.length - 1 && (
                  <Typography variant="h6" gutterBottom component="span">
                    {", "}
                  </Typography>
                )}
              </Fragment>
            );
          })}
        </Typography>
      </GridItem>
      {modalType === "edit" && group?.childrenGroups.length === 0 && (
        <GridItem sm={2} md={2}>
          <SecurityGuard checkForRoles={[SecurityRole.AcGroupsDelete]}>
            <Typography align={"right"}>
              <MediumButton
                type={"button"}
                color={"error"}
                variant={"contained"}
                onClick={() => handleOpenModal(group.group.id, "delete")}
              >
                {t("l.btn.delete")}
              </MediumButton>
            </Typography>
          </SecurityGuard>
        </GridItem>
      )}
    </GridContainer>
  );
};

export default GroupHierarchyContent;
